// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';
import coreUtilsLib from 'coreUtilsLib';

const { blogAppPartNames } = coreUtilsLib;

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
  hide: false,
  title: 'add_section_label_postsgallery',
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.SCALE,
    iconEnabledForComps: {},
  },
  props: {
    image: 'blog/sections/postGallerySection.png',
    imageHover: null,
    items: [
      {
        id: 'Blog_Post_Gallery_1',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 697,
            height: 297,
            x: 19,
            y: 58,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.POSTS_GALLERY,
            viewName: 'PostsGalleryMediaBottom',
            appLogicCustomizations: [
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.style',
                value: 'Heading S',
                fieldId: 'title',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.style',
                value: 'Body M',
                fieldId: 'date',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Array',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.transition',
                value: 'horizSwipeAllAtOnce',
                fieldId: 'postsGallery',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Array',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.rows',
                value: '1',
                fieldId: 'postsGallery',
                format: '',
              },
            ],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_1b8c501f-ccc2-47e7-952a-47e264752614_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74zy4hy_1',
        },
        preset: { rect: { width: 162, height: 111, x: 0, y: 0 }, label: '' },
      },
      {
        id: 'Blog_Post_Gallery_2',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 697,
            height: 297,
            x: 776,
            y: 58,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.POSTS_GALLERY,
            viewName: 'PostsGalleryMediaTop',
            appLogicCustomizations: [
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsGalleryMediaTop',
                key: 'comp.style',
                value: 'Heading S',
                fieldId: 'title',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.style',
                value: 'Body M',
                fieldId: 'date',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Array',
                view: 'PostsGalleryMediaBottom',
                key: 'comp.transition',
                value: 'horizSwipeAllAtOnce',
                fieldId: 'postsGallery',
                format: '*',
              },
            ],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_1b8c501f-ccc2-47e7-952a-47e264752614_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74zy4i0_5',
        },
        preset: { rect: { width: 162, height: 111, x: 162, y: 0 }, label: '' },
      },
    ],
    compTypes: ['wixapps.integration.components.AppPart'],
  },
  help: { hide: false, text: 'add_section_info_text_postsgallery' },
};
